import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IEditorService = ( createDecorator('editorService'));
export { IEditorService };
